export default __webpack_public_path__ + "static/media/slogan.9af538f0.png";